import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const propTypes = {
  onOpenNoNeed: PropTypes.func.isRequired,
  open: PropTypes.string.isRequired,
};

export default function OpenNoNeedRadioButton(props) {
  const { open, onOpenNoNeed } = props;

  return (
    <PageContainer>
      <h4>Nepovinná pole:</h4>
      <StyledRadioGroup
        aria-label='Splatnost úvěru'
        name='splatnostUveru'
        value={open}
        onChange={onOpenNoNeed}
      >
        <FormControlLabel
          value='ano'
          control={<Radio color='primary' />}
          label='Mám zájem o vyplnění'
          labelPlacement='start'
        />
        <FormControlLabel
          value='ne'
          control={<Radio color='primary' checked={open === 'ne'} />}
          label='Nepřeji si vyplnit'
          labelPlacement='start'
        />
      </StyledRadioGroup>
    </PageContainer>
  );
}

OpenNoNeedRadioButton.propTypes = propTypes;

const StyledRadioGroup = styled(RadioGroup)`
  flex-direction: row !important;
  justify-content: space-around;
  align-items: center;
  @media(max-width: 450px) {
    justify-content: flex-start;
  }
`;
const PageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media(max-width: 450px) {
    flex-direction: column;
  }
`;
